import { render, staticRenderFns } from "./businessModel.vue?vue&type=template&id=4192b8e4&scoped=true&"
import script from "./businessModel.vue?vue&type=script&lang=js&"
export * from "./businessModel.vue?vue&type=script&lang=js&"
import style0 from "./businessModel.vue?vue&type=style&index=0&id=4192b8e4&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4192b8e4",
  null
  
)

export default component.exports